import React, { Component } from 'react';
import './Steps.css';

class Steps extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = ({
      totalSteps: 0,
    });
  }

  generarClassStep = (stepIn, stepActual) => {
    let string;
    const step = stepIn + 1;
    if (stepActual > step) {
      string = 'active';
    } else if (stepActual === step) {
      string = 'classStepActual active';
    } else {
      string = '';
    }
    return string;
  }

  sumarSteps=(index)=>{
    const {totalSteps}=this.state;
    const {idFlujo}=this.props;
    let incremento;
    if(idFlujo!==3){
      if(index===0){incremento = 1}else{incremento = totalSteps+1}
    }else if(idFlujo===3){
      if(index===1 || index===0 ){incremento = 1}else{incremento = totalSteps+1}
    }
    this.state.totalSteps=incremento;    
    return incremento;
  }

  render() {
    const { stepActual, steps, titulo, idFlujo, subTitulo } = this.props;
    const stepsConstruidos = steps.map((item, index) => (
      <div key={item.step} className={`${idFlujo === 1 || idFlujo === 2 || idFlujo === 3 ? 'menuClassUno' : 'menuClassDos'} col ${this.generarClassStep(index, stepActual)}`}>
        <span />
        <p>{`${index+1}. ${item.step}`}</p>
      </div>
    ));

    const stepsResponsiveConstruidos = steps.map((item, index) => item.step!=null ? (
      <div key={item.step} style={{display:index===(stepActual-1)? 'block':'none'}} className={`${idFlujo === 1  ? 'menuClassUno' : 'menuClassDos'} col ${this.generarClassStep(index, stepActual)}`}>
        <p>{`${this.sumarSteps(index)}. ${item.step}`}</p>
        <p>{`${stepActual}/${steps.length}`}</p>
      </div>
    ):(<div key={item.step} />));

    return (
      <>
        <div className={`${idFlujo === 1 || idFlujo === 2 || idFlujo === 3 ? 'menuClassUno' : 'menuClassDos'} container-fluid headerTituloPage`}>
          <div className={`${idFlujo === 1 || idFlujo === 2 || idFlujo === 3 ? 'menuClassUno' : 'menuClassDos'} row no-gutters`}>
            <div className={`${idFlujo === 1 || idFlujo === 2 || idFlujo === 3 ? 'menuClassUno' : 'menuClassDos'} col-sm-10 offset-sm-1`}>
              {stepActual && (
                <div className="row">
                  <div className="col-12 mbottom30">
                    {titulo !== "" && <h1 className="txtAlignL mbottom0">{titulo}</h1>}
                    {subTitulo !== "" && <p className="txtAlignL ptop0 ">{subTitulo}</p>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={`${idFlujo === 1 || idFlujo === 2 || idFlujo === 3 ? 'menuClassUno' : 'menuClassDos'} container-fluid Steps`}>
          {stepActual && (
            <div className="row ptop40">
              <div className="col-sm-10 offset-sm-1">
                <div className={`${idFlujo === 1 || idFlujo === 2 || idFlujo === 3 ? 'menuClassUno' : 'menuClassDos'} row stepsCounter`}>
                  {stepsConstruidos}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={`${idFlujo === 1 ? 'menuClassUno' : 'menuClassDos'} container-fluid StepsResponsive`}>
          {stepActual && (
            <div className="ptop40">
              <div className="col-12 col-sm-12 col-md-11">
                <div className={`${idFlujo === 1 ? 'menuClassUno' : 'menuClassDos'} row stepsCounter`}>
                  <span className="back" />
                  <span style={{width:`${((100/steps.length)*stepActual)}%`}} />
                  {stepsResponsiveConstruidos}
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    )
  }
}

export default Steps;